import React from "react";
import { StripeProvider } from "../shared/context/StripeContext";
import OnboardingPage from "./index";

/**
 * Wrapper component that provides Stripe context only for the onboarding page
 * This ensures Stripe API calls only happen when users visit the onboarding route
 */
const OnboardingPageWithStripe = (props) => {
  return (
    <StripeProvider>
      <OnboardingPage {...props} />
    </StripeProvider>
  );
};

export default OnboardingPageWithStripe;
